export enum ModoBusqueda 
{
    empieza = '1',
    contiene = '2',
    acaba = '3',
    codigoDescripcion='4',
    codigoExacto='5'
}